import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTS } from 'src/app/core/config/constants';
import { Observable, of } from 'rxjs';
import { LocalStorageService } from '../helper/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public items = [];
  constructor(private httpClient: HttpClient,
    private localStorageService: LocalStorageService) { }

  /**
   * Finding "Clear text submission of password" — fetch a single-use RSA
   * challenge (public key) to encrypt the password against before login.
   * @returns Observable with { data: { challenge_id, public_key } }
   */
  getLoginChallenge(): Observable<any> {
    return this.httpClient.post<any>(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.LOGIN_CHALLENGE, {});
  }

  /**
   * Do login. Body carries { email, encrypted_password, challenge_id } for a
   * normal login — never a plaintext password (see LoginCryptoService). The
   * Google-auth path (isGoogleAuth/googleAuthToken) is unaffected.
   * @param invoiceDto
   * @returns
   */
  login(loginDto: any): Observable<any> {
    return this.httpClient.post(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.LOGIN, loginDto);
  }


   /**
   * Refresh token 
   * @param loginDto 
   * @returns 
   */
   refreshToken(loginDto: any): Observable<any> { 
    return this.httpClient.post(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.REFRESH_TOKEN,loginDto);
  }

  
  logout(): Observable<any> {
    return this.httpClient.get(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.LOGOUT);
  }

  /**
   * check user already logged in
   */
  get isLoggedIn(): boolean {
    let user: any = this.localStorageService.getUser();
    var status : boolean = false;
    if(Object.keys(user).length === 0 && user.constructor === Object){
      return status;
    }
    if(user.email !== undefined){
        status = true;
    }
    return status;
  }

 

  //hits the backend api
  LoginWithGoogle(credentials: string): Observable<any> {
    const isGoogleAuth = true;
    const googleAuthToken = credentials;
    const timezone_offset=(new Date().getTimezoneOffset() / -60).toString()
    const loginDto = { googleAuthToken, isGoogleAuth ,timezone_offset}
    return this.httpClient.post(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.LOGIN, loginDto);
  }

  signupWithGoogle(credentials: string): Observable<any> {
    const isGoogleAuth = true;
    const googleAuthToken = credentials;
    const timezone_offset=(new Date().getTimezoneOffset() / -60).toString()
    const signupDto = { googleAuthToken, isGoogleAuth,timezone_offset }
    return this.httpClient.post(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.SIGNUP, signupDto);
  }

  signup(data: any): Observable<any> {
    return this.httpClient.post(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.SIGNUP, data);
    // return this.httpClient.post("http://localhost:3000/payfills-auth/v1/signup", data);
  }

  resendsignupemail(data: any): Observable<any> {
    return this.httpClient.post(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.RESEND_EMAIL, data);
    // return this.httpClient.post("http://localhost:3000/payfills-auth/v1/signup", data);
  }

  forgotPassword(forgotPassword: any): Observable<any> {
    return this.httpClient.post(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.FORGOTPASSWORD, forgotPassword);
  }

  verifyOtp(dto: { email: string; otp: string }): Observable<any> {
    return this.httpClient.post<any>(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.VERIFYOTP, dto);
  }

  resetPassword(dto: { reset_token: string; password: string }): Observable<any> {
    return this.httpClient.post<any>(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.RESETPASSWORD, dto);
  }

  verify(credentials): Observable<any> {
    return this.httpClient.post<any>(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.AUTHENTICATION.VERIFY, credentials);
  }

}
